import { useMutation } from '@tanstack/react-query';
import { settingsService } from '../services/settings.service';
import type { DeleteAccountData } from '../types/settings.types';

export function useDeleteAccount() {
  return useMutation({
    mutationFn: (data: DeleteAccountData) => settingsService.deleteAccount(data),
  });
}
